/**
 * Search Widget for Homepage
 * Handles activity/location filtering and redirect
 */
$(function() {
    var $widget = $('#search-widget');
    if (!$widget.length) return;

    var searchData = $widget.data('search');
    var $activitySelect = $('#search-activity');
    var $locationSelect = $('#search-where');
    var $searchBtn = $('#search-btn');

    var selectedActivityTitle = null;
    var selectedLocationId = null;
    var defaultLocationPlaceholder = $locationSelect.find('option:first').text();

    /**
     * Get available locations for an activity
     */
    function getLocationsForActivity(activityTitle) {
        var locationIds = [];
        searchData.entries.forEach(function(entry) {
            if (entry.title === activityTitle && locationIds.indexOf(entry.locationId) === -1) {
                locationIds.push(entry.locationId);
            }
        });
        return searchData.locations.filter(function(location) {
            return locationIds.indexOf(location.id) !== -1;
        });
    }

    /**
     * Get URL for activity + location combination
     */
    function getRedirectUrl(activityTitle, locationId) {
        var entry = searchData.entries.find(function(e) {
            return e.title === activityTitle && e.locationId === locationId;
        });
        return entry ? entry.url : null;
    }

    /**
     * Update location dropdown based on selected activity
     */
    function updateLocationOptions() {
        $locationSelect.empty();
        $locationSelect.append('<option value="">' + defaultLocationPlaceholder + '</option>');

        if (!selectedActivityTitle) {
            $locationSelect.prop('disabled', true);
            return;
        }

        var locations = getLocationsForActivity(selectedActivityTitle);
        locations.forEach(function(location) {
            $locationSelect.append(
                $('<option>').val(location.id).text(location.name)
            );
        });

        $locationSelect.prop('disabled', locations.length === 0);
    }

    /**
     * Update search button state
     */
    function updateSearchButton() {
        var hasValidSelection = selectedActivityTitle && selectedLocationId
            && getRedirectUrl(selectedActivityTitle, selectedLocationId);
        $searchBtn.prop('disabled', !hasValidSelection);
    }

    // Event: Activity changed
    $activitySelect.on('change', function() {
        selectedActivityTitle = $(this).val() || null;
        selectedLocationId = null;
        $locationSelect.val('');
        updateLocationOptions();
        updateSearchButton();
    });

    // Event: Location changed
    $locationSelect.on('change', function() {
        selectedLocationId = parseInt($(this).val()) || null;
        updateSearchButton();
    });

    // Event: Search button clicked
    $searchBtn.on('click', function(e) {
        e.preventDefault();

        var url = getRedirectUrl(selectedActivityTitle, selectedLocationId);
        if (url) {
            window.location.href = url;
        }
    });
});
